<template>
  <div class="main">
    <report-top> </report-top>

    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button>
        <Button v-if="false" @click="dayin" type="primary" class="chaxun">打印</Button>

      </template></selectTool>
    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)" @on-selection-change="selectTableData = $event">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" v-if="row.appraise == null" @click="openPingjia(row)">评价</Button>
        <Tag color="red" v-else> {{ row.appraise }}星 </Tag>
      </template>
      <template slot-scope="{ row, index }" slot="passengers">
        <ul>
          <li v-for="(x, index) in row.passengers" :key="index">
            {{ x.name }}/{{ x.tel }}
          </li>
        </ul>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button size="small" @click="guiji(row, index)">轨迹</Button>
        <Button size="small" @click="exportAll(row)" class="chaxun">打印</Button>
        <Button size="small" v-if="row.optStatus != 6" @click="cheHui(row)">作废</Button>
      </template>
    </Table>
    <div id="mypage">
      <div style="float:left;display: flex;">
        <h4>累计里程：{{ mileage }}/km</h4>
        <h4 style="margin-left: 20px;">累计时长：{{ duration }}/分钟</h4>
        <h4 style="margin-left: 20px;">累计行程费用：{{ cost }}/元</h4>
        <h4 style="margin-left: 20px;">累计附加费用：{{ surcharge }}/元</h4>
      </div>
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <Modal v-model="openApplyForm" title="用车评价" footer-hide width="400" height="400">
      <Form ref="applyItem" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
          <FormItem label="评价分数" prop="appraise">
            <Rate show-text allow-half v-model="item.appraise"><span style="color: #f5a623">{{ item.appraise }}分</span>
            </Rate>
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="pingjia('applyItem')">立即评价</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <dayin ref="dayin"></dayin>
    <form-model title="行车轨迹" :overAuto="true" width="400" ref="map" fullscreen>
      <div slot="topcontent" style="width: 100%; height: 100%">
        <locusMap ref="locusMap"></locusMap>
      </div>
    </form-model>
  </div>
</template>
<script>
import fields from "./forms/fields";
import dayin from "./dayin.vue";
import locusMap from "../map/locusMap.vue";
export default {
  components: { dayin, locusMap },
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
        },
        {
          title: "工单号",
          key: "no",
          width: 150,
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "驾驶员",
          key: "driverName",
        },
        {
          title: "计费方式",
          key: "ruleName",
        },
        {
          title: "总里程/公里",
          key: "mileage",
        },
        {
          title: "总时长/分",
          key: "duration",
        },
        {
          title: "行程费用/元",
          key: "cost",
          width: 130
        },
        {
          title: "附加费用/元",
          key: "surcharge",
          width: 130
        },
        {
          title: "实际出发时间",
          key: "realStartTime2",
          width: 130
        },
        {
          title: "实际出发地点",
          key: "realStartAdd",
          minWidth: 200,
          maxWidth: 300,
          span: 12
        },
        {
          title: "实际出发里程",
          key: "realStartMileage",
          span: 12
        },
        {
          title: "实际结束时间",
          key: "realEndTime2",
          width: 130
        },
        {
          title: "实际结束里程",
          key: "realEndMileage",
        },
        {
          title: "实际结束地点",
          key: "realEndAdd",
          minWidth: 200,
          maxWidth: 300,
          span: 12
        },
        {
          title: "评价/分",
          key: "appraise",
          slot: "action",
          fixed: "right",
          sort: 50,
          width: 100,
          span: 24,
        },
        {
          title: "操作",
          key: "appraise",
          slot: "action1",
          fixed: "right",
          noTable: true,
          sort: 51,
          width: 150,
        },
      ],
      tableData: [],
      selectTableData: [],
      total: 0,
      searchItem: {
        driverAccountId:[],
        groupIdList:[],
        carIdList:[],
        endTime: 0,
        startTime: 0,
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        taskStatus: 3, //0-全部，1-待办，2-进行，3-完成
        optStatus: 0//6--作废 0--正常
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "订单号",
          key: "no",
          type: "Input",
        },
        {
          title: "选择单位",
          groupIds: "groupIdList",
          clearable: true,
          more:true,
          type: "selectGroup",
        },
        {
          title: "车牌号",
          carIdList: "carIdList",
          type: "selectAlotCar",
        },
        {
          title: "驾驶员",
          accountIds: "driverAccountId",
          //key4: "ffff",
          type: "selectUser",
          keyword: '司机',
          more:true
        },
      ],
      forms: fields["yongcheshenqing"],
      openApplyForm: false,
      item: { appraise: 5, id: "" },
      ruleValidate: {
        appraise: { required: true, message: "必填" },
      },
      mileage: 0,
      cost: 0,
      duration: 0,
      surcharge: 0
    };
  },
  methods: {
    getList() {
     // this.ssear();
      console.log(this.searchItem);
      
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpc + "/apply/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
       
        if (res) {
         // this.total = res.data.data.total;
          var data = res.data.data.dataList;
          for (let i = 0; i < data.length; i++) {
            data[i].planStartTime2 = this.utils.time(
              data[i].planStartTime,
              "yymmddhhmm"
            );
            data[i].planReachTime2 = this.utils.time(
              data[i].planReachTime,
              "yymmddhhmm"
            );
            data[i].planEndTime2 = this.utils.time(
              data[i].planEndTime,
              "yymmddhhmm"
            );
            data[i].realStartTime2 = this.utils.time(
              data[i].realStartTime,
              "yymmddhhmm"
            );
            data[i].realReachTime2 = this.utils.time(
              data[i].realReachTime,
              "yymmddhhmm"
            );
            data[i].realEndTime2 = this.utils.time(
              data[i].realEndTime,
              "yymmddhhmm"
            );
          }
          this.tableData = data;
          this.leiji(data);
        }
      });
    },
    leiji(data) {
      var duration = 0, cost = 0, mileage = 0, surcharge = 0;
      for (let i = 0; i < data.length; i++) {
        duration += Number(data[i].duration);
        cost += data[i].cost;
        mileage += data[i].mileage;
        surcharge += data[i].surcharge;

      }
      this.duration = duration;
      this.cost = cost.toFixed(2);
      this.mileage = mileage.toFixed(2);
      this.surcharge = surcharge.toFixed(2);
      //console.log(this.cost, this.mileage, this.duration);
    },
    ssear() {
      if (!this.utils.isEmpty(this.searchItem.groupId)) {
        this.searchItem.groupIdList = [this.searchItem.groupId];
      }

      
    },
    exportAll(x) {
      var params = [
        {
          name: "no",
          value: x.no,
        },

      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-ofc-server-web/dpcApply/exportWord", params);
    },
    detail(row) {
      var a = this.selectTableData;
      for (let i = 0; i < a.length; i++) {
        this.utils.loading(this, "加载中");
        this.axios({
          method: "post",
          url: this.axios.dpc + "/apply/item",
          data: { id: a[i].id },
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          a[i].qianzi = res.data.data.signList;
          if (i == this.selectTableData.length - 1) {
            this.$refs.dayin.reach(this.selectTableData, this.columns);
          }
        });
      }
    },
    openPingjia(row) {
      this.openApplyForm = true;
      this.item.id = row.id;
    },
    pingjia(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.utils.loading(this, "加载中");
          this.axios({
            method: "post",
            url: this.axios.dpc + "/apply/appraise",
            data: this.item,
          }).then((res) => {
            console.log(res);
            this.$Spin.hide(); //关闭加载
            if (res) {
              this.openApplyForm = false;
              this.getList();
            }
          });
        }
      });
    },
    //订单撤回
    cheHui(data) {
      this.$Modal.confirm({
        title: "是否作废？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-ofc-server-web/dpcApply/cancelApply",
            data: {
              "no": data.no
            },
          }).then((res) => {
            console.log(res);
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    dayin() {
      if (this.selectTableData.length == 0) {
        this.$Message.error("请选择条目");
        return;
      }
      this.detail();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    search() {
      this.reset();
      this.getList();
    },
    guiji(x) {
      this.$refs.map.reach([], {});
      let params = {
        deviceNo: x.deviceNo,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: x.realReachTime,
        startTime: x.realStartTime,
      };
      /*let params = {
        deviceNo: '14149984024',
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: new Date(2023,9,24,10).getTime(),
        startTime: new Date(2023,9,24,8).getTime(),
      };*/
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locus/getPlyLocus",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.otherData = data;
        //如果有轨迹在播放，先销毁
        if (this.$store.state.carMsg.play != 1) {
          this.$refs.gmap.play(4);
          this.$store.state.carMsg.play = 1;
        }
        if (res.data.code == 200) {
          if (data.length >= 1) {
            var lnglat = [];
            for (let i = 0; i < data.length; i++) {
              lnglat.push([data[i].returnX, data[i].returnY]);
              data[i].tms = data[i].gpsTime / 1000;
              data[i].locateLng = data[i].returnX;
              data[i].locateLat = data[i].returnY;
              data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
              data[i].reportTime = this.utils.time(data[i].reportTime);
              data[i].startParkTime = this.utils.time(data[i].startParkTime);
              data[i].endParkTime = this.utils.time(data[i].endParkTime);
              data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);
              //console.log(data[i].directionDegree,data[i].deviceStatus,data[i].mileage);
            }

            this.$refs.locusMap.loadUi(lnglat, data); //渲染轨迹
            if (this.showPark) {
              this.$refs.gmap.showpark(this.otherData, this.duration); //停车点
            }
            this.$store.state.control = true;
          } else if (data.length == 0) {
            this.$Message.error("暂无轨迹");
            this.$refs.gmap.loadUi([], []); //清空轨迹
            this.$refs.gmap.showpark([], 0); //清空停车点
            this.$store.state.control = false;
          }
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/diaodu/diaodudan.vue